import { ArchitectureDiagram } from "../PaperShared/ArchitectureDiagram";

function FeatureExtraction() {
  return (
    <section id="FeatureExtraction">
      <h2>Feature Extraction</h2>
      <p>
        In the field of mechanistic interpretability, features represent the internal “building
        blocks” that a model uses to produce predictions. Ideal features are “interpretable” and
        “sparsely activated”. One may naively expect that the neurons of a neural network would
        produce such features; however, neural activations are noisy and yield an opaque
        understanding of what’s happening inside a model.
      </p>
      <p>
        Lately, interpretability researchers have been using “
        <a
          href="https://adamkarvonen.github.io/machine_learning/2024/06/11/sae-intuitions.html"
          target="_blank"
          rel="noreferrer"
        >
          sparse autoencoders
        </a>
        ” to extract sets of interpretable features from individual layers of activity, which is
        what this app uses as a prerequisite to circuit extraction. We specifically use a “
        <a href="https://arxiv.org/pdf/2404.16014" target="_blank" rel="noreferrer">
          Gated sparse autoencoder
        </a>
        ” (a.k.a Gated SAE) to produce features representing the activations of the residual stream
        before and after every transformer block in an LLM. Additionally, we’re tying encoder
        weights to decoder weights to reduce the impact of{" "}
        <a
          href="https://www.lesswrong.com/posts/kcg58WhRxFA9hv9vN"
          target="_blank"
          rel="noreferrer"
        >
          feature absorption
        </a>
        .
      </p>
      <ArchitectureDiagram />
    </section>
  );
}

export { FeatureExtraction };
